import { t } from "@bookingcom/lingojs-core";
import { UIPrice, UIPriceBreakdown } from "@flights/types";
import { I18nChildContext, useI18n } from "@bookingcom/lingojs-react";
import flights_apex_web_ryanair_ancillaries_price_label from "../utils/experiments/apex/flights_apex_web_ryanair_ancillaries_price_label";
import useFormatPrice from "../hooks/useFormatPrice";
import { useCallback } from "react";
import { isFeatureRunningClientSide, pricingUtils } from "@flights/web-api-utils-universal";

export const useRyanAirAncillaryPriceLabel = () => {
  const i18n = useI18n() as I18nChildContext;
  const { formatPrice, priceIsZero, priceToValue } = useFormatPrice();

  const getRyanAirPriceLabel = useCallback(
    (priceBreakdown?: UIPriceBreakdown | null, shouldReturnLabel?: boolean) => {
      if (!priceBreakdown) return undefined;
      if (priceIsZero(priceBreakdown.total)) return undefined;
      const { carrierPriceBreakdown, fee, bcomPricingItems } = priceBreakdown;
      if (
        carrierPriceBreakdown &&
        (shouldReturnLabel ||
          carrierPriceBreakdown.some(({ marketingCarrier }) => marketingCarrier == "FR" || marketingCarrier == "RK")) &&
        flights_apex_web_ryanair_ancillaries_price_label.trackWithDefaultStage() > 0
      ) {
        const airlinePriceTags = carrierPriceBreakdown
          .filter(({ baseFare }) => !priceIsZero(baseFare))
          .map((breakdown) =>
            i18n.trans(
              t("flights_ryanair_dynamic_price", {
                variables: {
                  price: formatPrice(breakdown.baseFare),
                  airline: breakdown.marketingCarrierName
                }
              })
            )
          )
          .join(" + ");
        let effectiveFee: UIPrice = fee;
        if (isFeatureRunningClientSide("FLIGHTS_APEX_WEB_RYANAIR_PRICE_LABEL_UPDATE")) {
          if (bcomPricingItems) {
            effectiveFee = bcomPricingItems.reduce((acc, curr) => pricingUtils.sumPrice(acc, curr.amount), fee);
          }
          if (priceToValue(effectiveFee) < 0) {
            return i18n.trans(
              t("flights_ryanair_bags_seats_savings", {
                variables: {
                  airline_price_tags: airlinePriceTags,
                  savings_amount: formatPrice(effectiveFee, { isDiscount: true })
                }
              })
            );
          }
        }
        if (priceIsZero(effectiveFee)) {
          return airlinePriceTags;
        }
        return i18n.trans(
          t("flights_fd_baggage_ryanair_fare", {
            variables: {
              airline_price_tags: airlinePriceTags,
              third_party_fee_amount: formatPrice(effectiveFee)
            }
          })
        );
      }
      return undefined;
    },
    [priceIsZero, priceToValue, i18n, formatPrice]
  );
  return {
    getRyanAirPriceLabel
  };
};
